module.exports = __webpack_public_path__ + "static/media/emailme.4faca72b.png";